import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloat = () => {
  const phoneNumber = "2348122439465"; 
  const message = encodeURIComponent(
    "Hi Pelumi, I saw your portfolio and I’d like to discuss a project."
  );

  return (
    <motion.a
      href={`https://wa.me/${phoneNumber}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      transition={{ duration: 0.25, ease: "easeOut" }}
      className="
        fixed
        bottom-5
        right-5
        z-50
        flex
        h-11
        w-11
        items-center
        justify-center
        rounded-full
        bg-[#25D366]
        text-white
        shadow-md
        hover:shadow-lg
      "
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="text-xl" />
    </motion.a>
  );
};

export default WhatsAppFloat;
